import type { FolderListItem } from "../types/folder.types.ts"

/** The item count a folder shows: its files plus its subfolders. */
export const folderItemCount = (
  folder: Pick<FolderListItem, "files_count" | "children_count">
): number => folder.files_count + folder.children_count
